module.exports = __webpack_public_path__ + "img/Lucas Torreira.cb104723.png";